// frontend/src/pages/LeaveApplication.jsx
import React, { useState } from 'react';
import Layout from '../components/Layout.jsx';
import axiosInstance from '../services/axiosInstance';
import { toast, Toaster } from 'react-hot-toast';

const LeaveApplication = () => {
  const [form, setForm] = useState({ 
    leave_type: 'annual', 
    from_date: '', 
    to_date: '', 
    reason: '', 
    half_day: false 
  });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await axiosInstance.post('/api/leaves/apply', form);
      if (res.data.success) {
        toast.success('Leave requested! Email sent to reporting manager');
        setForm({ leave_type: 'annual', from_date: '', to_date: '', reason: '', half_day: false });
      } else {
        toast.error(res.data.message || 'Failed');
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || err.message || 'Failed');
    } finally { 
      setSubmitting(false);
    }
  };

  const calculateDays = () => {
    if (!form.from_date || !form.to_date) return 0;
    const from = new Date(form.from_date);
    const to = new Date(form.to_date);
    const diffTime = Math.abs(to - from);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return form.half_day ? diffDays - 0.5 : diffDays;
  };

  return (
    <Layout>
      <Toaster position="top-right" />
      <div className="container mt-4">
        <div className="card shadow-sm">
          <div className="card-header bg-white py-3">
            <h5 className="mb-0">
              <i className="fas fa-calendar-alt text-primary me-2"></i>
              Leave Application
            </h5>
          </div>
          <div className="card-body">
            <form onSubmit={submit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Leave Type</label>
                  <select 
                    className="form-select" 
                    value={form.leave_type} 
                    onChange={e => setForm({...form, leave_type: e.target.value})}
                  >
                    <option value="annual">🏖️ Annual Leave</option>
                    <option value="medical">🏥 Medical Leave</option>
                    <option value="casual">🎉 Casual Leave</option>
                    <option value="other">📝 Other</option>
                  </select>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Duration</label>
                  <div className="input-group">
                    <input 
                      type="date" 
                      className="form-control" 
                      value={form.from_date} 
                      onChange={e => setForm({...form, from_date: e.target.value})} 
                      required 
                    />
                    <span className="input-group-text">to</span>
                    <input 
                      type="date" 
                      className="form-control" 
                      value={form.to_date} 
                      onChange={e => setForm({...form, to_date: e.target.value})} 
                      required 
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <div className="form-check">
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    checked={form.half_day} 
                    onChange={e => setForm({...form, half_day: e.target.checked})} 
                    id="halfday" 
                  />
                  <label className="form-check-label" htmlFor="halfday">
                    Half Day Leave
                  </label>
                </div>
                {form.from_date && form.to_date && (
                  <small className="text-muted">
                    Total: {calculateDays()} day(s) requested
                  </small>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Reason</label>
                <textarea 
                  className="form-control" 
                  rows="3" 
                  value={form.reason} 
                  onChange={e => setForm({...form, reason: e.target.value})} 
                  required 
                  placeholder="Please provide reason for leave..."
                />
              </div>

              <div className="d-flex justify-content-end gap-2">
                <button 
                  type="button" 
                  className="btn btn-light" 
                  onClick={() => setForm({ leave_type: 'annual', from_date: '', to_date: '', reason: '', half_day: false })}
                >
                  Reset
                </button>
                <button 
                  type="submit" 
                  className="btn btn-primary" 
                  disabled={submitting}
                >
                  {submitting ? 'Submitting...' : 'Apply Leave'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LeaveApplication;